import { render } from "./NavigationPanelEditorCmp.vue?vue&type=template&id=05cab438"
import script from "./NavigationPanelEditorCmp.vue?vue&type=script&lang=js"
export * from "./NavigationPanelEditorCmp.vue?vue&type=script&lang=js"

import "./NavigationPanelEditorCmp.vue?vue&type=style&index=0&id=05cab438&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__